module.exports = __webpack_public_path__ + "static/media/5.565e53a7.jpg";